import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DynamicDialogConfig, DynamicDialogRef } from '@openng/optimus-ui/dynamicdialog';
import { Auth } from '@angular/fire/auth';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize, first } from 'rxjs';

import { NotificationService } from '@shared/services/notifications/notification.service';
import {
  EmailVerificationDialogData,
  EmailVerificationService,
} from '../../service/email-verification.service';

@Component({
  selector: 'app-email-verification-dialog',
  standalone: true,
  templateUrl: './email-verification-dialog.component.html',
  styleUrls: ['./email-verification-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonModule, TranslateModule],
})
export class EmailVerificationDialogComponent {
  public ref: DynamicDialogRef = inject(DynamicDialogRef);
  private config: DynamicDialogConfig = inject(DynamicDialogConfig);
  private emailVerificationService: EmailVerificationService = inject(EmailVerificationService);
  private notificationService: NotificationService = inject(NotificationService);
  private translateService: TranslateService = inject(TranslateService);
  private auth: Auth = inject(Auth);

  email: string = this.auth.currentUser?.email ?? '';
  data: EmailVerificationDialogData = this.config.data;
  sending: boolean = false;
  sent: boolean = false;

  onSend(): void {
    this.sending = true;
    this.emailVerificationService
      .sendVerificationEmail()
      .pipe(
        first(),
        finalize(() => (this.sending = false))
      )
      .subscribe({
        next: () => (this.sent = true),
        error: (error) =>
          this.notificationService.show(
            'Error',
            this.translateService.instant('emailVerification.sendError'),
            'error',
            error
          ),
      });
  }
}
